import { render, staticRenderFns } from "./ResearchDirectionsBannerBottom.vue?vue&type=template&id=547fe2c4&scoped=true"
import script from "./ResearchDirectionsBannerBottom.vue?vue&type=script&lang=js"
export * from "./ResearchDirectionsBannerBottom.vue?vue&type=script&lang=js"
import style0 from "./ResearchDirectionsBannerBottom.vue?vue&type=style&index=0&id=547fe2c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547fe2c4",
  null
  
)

export default component.exports